import { render, staticRenderFns } from "./AddEditHoliday.vue?vue&type=template&id=6f2b2f74"
import script from "./AddEditHoliday.vue?vue&type=script&lang=js"
export * from "./AddEditHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports